import moment from 'moment';
import { REPORT_DATA_TYPE } from "../../config/constants";
import modelBaseV2 from "../model-base-v2.model";

const ReportModel = {

  /// New Model Display Flooring - start

  getStatisticsForNewModelDisplayFlooring: function (filter) {
    // Set required default values
    const params = {
      week: '',
      locations: [],
      buChannelType: '',
      buAccount: '',
      gscmDivision: '',
      productCategories: [],
      modelCodes: [],
      statusCode: '',
    }

    Object.assign(params, filter);

    return modelBaseV2.post('/api/report/display/newmodeldisplayflooring', { body: params });
  },

  getDetailsForNewModelDisplayFlooring: function (filter) {
    // Set required default values
    const params = {
      week: '',
      locations: [],
      buChannelType: '',
      buAccount: '',
      gscmDivision: '',
      productCategories: [],
      modelCodes: [],
      statusCode: '',
    }

    Object.assign(params, filter);

    return modelBaseV2.post('/api/report/display/newmodeldisplayflooring/detail', { body: params });
  },

  exportNewModelDisplayFlooringDetailsToExcel: function (filter, fileName = `New Model Display Flooring - ${moment().format('YYYYMMDDHHmm')}.xlsx`) {
    return modelBaseV2.postDownload('/api/report/display/newmodeldisplayflooring/file/excel', { body: filter }, fileName);
  },

  exportNewModelDisplayFlooringDetailsToPptx: function (filter, fileName = `New Model Display Flooring - ${moment().format('YYYYMMDDHHmm')}.pptx`) {
    return modelBaseV2.postDownload('/api/report/display/newmodeldisplayflooring/file/pptx', { body: filter }, fileName);
  },

  /// New Model Display Flooring - end

  /// Reports - start

  /**
   * Get report configurations
   * @param {*} params 
   * @returns {Promise} Promise object represents the report configurations
   */
  getReportConfig: (params) => {
    const defaultParams = {
      dataType: '',
      dataCode: '',
      dataName: '',
      parameterDataCode: '',
    }
    Object.assign(defaultParams, params);
    return modelBaseV2.get('/api/report/config', { params: defaultParams });
  },

  /**
   * Get `DataSource` list of MobileReport
   */
  getMobileReportDataSource: function () {
    let params = {
      dataType: REPORT_DATA_TYPE.DATA_SOURCE,
      dataCode: 'MobileReport',
    }
    return this.getReportConfig(params);
  },

  /**
   * Get `ReportPeriod` list of MobileReport's `DataSource`
   */
  getReportPeriodByMobileReportDataSource: function (dataSourceCode) {
    let params = {
      dataType: REPORT_DATA_TYPE.MOBILE_REPORT_PERIOD,
      dataCode: dataSourceCode,
    }
    return this.getReportConfig(params);
  },

  /**
   * Get report configurations of `ReportPeriod` type
   */
  getReportConfigReportPeriod: function (dataSourceCode) {
    let params = {
      dataType: REPORT_DATA_TYPE.REPORT_PERIOD,
      dataCode: dataSourceCode,
    }
    return this.getReportConfig(params);
  },

  /**
   * Get report configurations of `DataGroup` type
   */
  getReportConfigDataGroup: function (dataSourceCode, periodCode, templateType) {
    let params = {
      dataType: REPORT_DATA_TYPE.DATA_GROUP,
      dataCode: dataSourceCode,
      dataName: periodCode,
      parameterDataCode: templateType,
    }
    return this.getReportConfig(params);
  },

  /**
   * Get report filter
   */
  getReportFilter: (dataSourceCode, periodCode) => {
    let params = {
      dataSourceCode,
      periodCode,
    }
    return modelBaseV2.get('/api/report/filter', { params });
  },

  /**
   * Get all axis properties of a report
   */
  getReportInfo: (dataSourceCode, periodCode) => {
    let params = {
      dataSourceCode,
      periodCode,
    }
    return modelBaseV2.get(`/api/report/info`, { params })
  },

  /**
   * Get report template list
   */
  getReportTemplateList: (params) => {
    return modelBaseV2.get('/api/report/template', { params });
  },

  /**
   * Save report template
   */
  saveReportTemplate: (body) => {
    return modelBaseV2.post('/api/report/template', { body });
  },

  /**
   * Get report template details by templateId
   */
  getReportTemplate: (templateId) => {
    return modelBaseV2.get('/api/report/template/:templateId', { params: { templateId } });
  },

  /**
   * Delete report template by templateId
   */
  deleteReportTemplate: (templateId) => {
    return modelBaseV2.post('/api/report/template/delete/:templateId', { params: { templateId } });
  },

  /**
   * Get report pivot data for Flexmonster
   */
  getReportData: (body, v='') => {
    return modelBaseV2.post('/api/report'+v+'/data', { body });
  },

  /**
   * Get report html data for Store Visit report
   */
  getReportHtmlData: (body, v='') => {
    return modelBaseV2.post('/api/report'+v+'/dataHtml', { body });
  },

  downloadReportData: (body, filename = uuidv4(), v='') => {
    return modelBaseV2.postDownload('/api/report'+v+'/data/download', { body }, filename);
  },
  downloadReportDataHtml: (body, fileName, v='') => {
    return modelBaseV2.postDownload('/api/report'+v+'/dataHtml/download', { body }, fileName)
  },
  /**
   * Get mobile report template list
   */
  getMobileReportTemplateList: (params) => {
    return modelBaseV2.get('/api/report/templatemobile', { params });
  },

  /**
   * Save a new / update an existing mobile report template
   */
  saveMobileReportTemplate: (body) => {
    return modelBaseV2.post('/api/report/templatemobile', { body });
  },

  /**
   * Get mobile report template by `templateId`
   */
  getMobileReportTemplate: (templateId) => {
    return modelBaseV2.get('/api/report/templatemobile/:templateId', { params: { templateId } });
  },

  /**
   * Decrypt
   */
  getDecryptedRSA: (val) => {
    let params = {
      value: val
    }
    return modelBaseV2.getPublic('/api/report/decrypt-rsa', { params });
  },

  /**
   * Delete mobile report template by `templateId`
   */
  deleteMobileReportTemplate: (templateId) => {
    return modelBaseV2.post('/api/report/templatemobile/delete/:templateId', { params: { templateId } });
  },

  /// Reports - end

}

export default ReportModel;